// extracted by mini-css-extract-plugin
export default {"body":"DefaultLayout_body__jT8G7","content":"DefaultLayout_content__T6KqC","content--nav-opened":"DefaultLayout_content--nav-opened__Ds11j"};